var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "ec-2-gif-previewer" }, [_c('div', { staticClass: "previewer" }, [_c('div', { staticClass: "preview-layout", class: _vm.layoutClass }, [_c('div', { staticClass: "portal" }, [_c('img', { class: {
      'default-img': !_vm.portalPreviewUrl,
      'preview-img': _vm.portalPreviewUrl
    }, attrs: { "src": _vm.portalPreviewUrl || _vm.defaultImg, "alt": "" } })]), _vm._v(" "), _c('div', { staticClass: "landscape" }, [_c('img', { class: {
      'default-img': !_vm.landscapePreviewUrl,
      'preview-img': _vm.landscapePreviewUrl
    }, attrs: { "src": _vm.landscapePreviewUrl || _vm.defaultImg, "alt": "" } })])])]), _vm._v(" "), _c('div', { staticClass: "action-bar" }, [_c('span', { staticClass: "portal layout-bt", class: { active: this.layoutType === 'portal' }, on: { "click": function click() {
        _vm.handleLayoutClick('portal');
      } } }), _vm._v(" "), _c('span', { staticClass: "landscape layout-bt", class: { active: this.layoutType === 'landscape' }, on: { "click": function click() {
        _vm.handleLayoutClick('landscape');
      } } })])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };